import { IconCheck } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { type DigestSummary, digestStatus } from '../lib/digests';
import { StatusPill } from './StatusPill';
import { buttonClass } from './ui/Button';

// One archive week as a .row-list row (mock SimplePage '/digests'): check tile +
// subject over a "Week of X" meta line with the lifecycle Status chip; ghost
// Open on the right triggers the reading drawer. Presenter — the Digests route
// owns the open state. The DB only stores the email header + HTML, so the row
// shows subject + week — no per-category counts (#199 demo structure, not
// persisted).

export type DigestCardProps = {
  readonly row: DigestSummary;
  readonly onOpen?: (row: DigestSummary) => void;
  readonly active?: boolean;
};

export function DigestCard(props: DigestCardProps): JSX.Element {
  const status = () => digestStatus(props.row);
  return (
    <li class="row-list__row digest-row">
      <div class="row-list__lead">
        <span class="row-list__tile">
          <IconCheck size="1rem" />
        </span>
        <span class="digest-row__id">
          <span class="digest-row__subject">{props.row.subject ?? t('digests.untitled')}</span>
          <span class="digest-row__meta">
            <span class="digest-row__week">
              {t('digests.week_of', { date: props.row.period_start.slice(0, 10) })}
            </span>
            <StatusPill tone={status() === 'opened' ? 'success' : 'neutral'}>
              {t(`digests.status_${status()}`)}
            </StatusPill>
          </span>
        </span>
      </div>
      <button
        type="button"
        class={`${buttonClass({ variant: 'ghost', size: 'sm' })} digest-row__open`}
        aria-current={props.active ? 'true' : undefined}
        aria-label={t('digests.open_aria', {
          week: t('digests.week_of', { date: props.row.period_start.slice(0, 10) }),
        })}
        onClick={() => props.onOpen?.(props.row)}
      >
        {t('digests.open')}
      </button>
    </li>
  );
}
